<div class="sidenav-content">
  <div class="bcontainer2">
    <div class="main-content">

    
    <div class="spacer5"></div>

    <div class="pcontainter">
      <div class="mfhd">
        <i
          class="fa fa-angle-left pointer"
          [routerLink]="['/workspace']"
          aria-hidden="true"
          style="padding-right: 5px"
        ></i
        >Workspace Configuration
      </div>

      <div class="spacer5"></div>

      <!-- <mat-progress-bar
        class="example-margin"
        [value]="pbValue"
      ></mat-progress-bar> -->


    <div class="stepper">
      <div class="step selected" [ngClass]="{ 'selected': createNav, 'success': !createNav }">
        <span class="circle">1</span>
        Create Workspace
      </div>  
      <div class="line"></div>
      <div class="step" [ngClass]="{ 'selected': downloadNav, 'success': !downloadNav && !createNav }">
        <span class="circle">2</span>
        Configure LLM Key
      </div>
      <div class="line"></div>
      <div class="step" [ngClass]="{ 'selected': planNav, 'success': !planNav && !createNav && !downloadNav }">
        <span class="circle">3</span>
        Choose Plan
      </div>
    </div>

      <!-- CREATE WORKSPACE  -->
      <div class="step-nav" *ngIf="createNav">
        <div class="form-fields" [formGroup]="createAPIKeyForm">
          <div class="step-container">
            <div class="spacer5"></div>


            <div class="wrow">

              <div class="wcolumn">

                 <div class="form-field" style="width: 100%">
                  <mat-label class="wid-80px">Name*</mat-label>
                  <mat-form-field
                appearance="fill"
                floatLabel="always"
                class="no-underline form-input"
              >
                <input
                  matInput
                  class="filter-input"
                  formControlName="name"
                  required
                />
                </mat-form-field>
                 </div>

                 <div class="spacer2"></div>

                <div class="form-field" style="width: 100%">
                  <mat-label class="wid-80px">Institution Id*</mat-label>
                  <mat-form-field
                    appearance="fill"
                    floatLabel="always"
                    class="no-underline form-input"
                  >
                    <input
                      matInput
                      class="filter-input"
                      formControlName="institutionId"
                      required
                    />
                  </mat-form-field>
                </div>

                <div class="spacer2"></div>

                <div class="form-field" style="width: 100%">
                <mat-label class="wid-80px">Institution Name*</mat-label>
                <mat-form-field
                  appearance="fill"
                  floatLabel="always"
                  class="no-underline form-input"
                >
                  <input
                    matInput
                    class="filter-input"
                    formControlName="institutionName"
                    required
                  />
                </mat-form-field>
              </div>

              </div>

              <div class="wcolumn nlist">
              <ul>
                <li>A workspace holds its own memories, profiles, and configurations.</li>
                <li>An ECDSA key pair is generated in-browser for secure API integration. The public key is sent to the server, while the private key is securely stored in the browser using the Web Cryptography API's secure key storage (commonly referred to as "CryptoDB").</li>
                <li>This ensures the private key never leaves the browser and is protected using hardware-backed or browser-enforced secure storage, depending on the device.</li>
                <li>All API requests are signed using this private key.</li>
                <li>For external or business use, you can generate a separate key pair (not stored in browser storage) from the workspace view.</li>
              </ul>       
            </div>
              
            </div>

          </div>

              <div class="button-container" style="text-align: right">
            <!-- <button mat-raised-button color="accent"  (click)="cancel()" class="ml5">{{ "Cancel" }}</button> -->
            <button
              mat-raised-button
              color="primary"
              (click)="submit()"
              class="clr-white"
              [disabled]="createAPIKeyForm.invalid"
            >
              {{ "Create" }}
            </button>
          </div>

        </div>    

      </div>
    <!-- CREATE WORKSPACE -->


    <!-- CONFIG WORKSPACE -->
      <div class="step-nav" *ngIf="downloadNav">

        <div [formGroup]="downloadKeyForm" class="form-fields">
          <div class="step-container" style="text-align: center">

            <div class="spacer5"></div>

            <!-- 
            <div class="infomsg" *ngIf="showInfoMsg">Privatekey download successfully.</div>
            <div class="spacer5"></div> -->

            <div class="form-field" style="width: 100%">
              <mat-label class="wid-80px">Identifier*</mat-label>
              <mat-form-field
                appearance="fill"
                floatLabel="always"
                class="form-input">
                <input
                 matInput
                      class="filter-input"
                      [formControl]="identifierControl"
                />
              </mat-form-field>             
            </div>

            <div class="spacer2"></div>

            <div class="form-field" style="width: 100%">
              <mat-label class="wid-80px">Configure LLM Key*</mat-label>
              <mat-form-field
                appearance="fill"
                floatLabel="always"
                class="form-input"
              >
                <input
                 matInput
                      class="filter-input"
                      [formControl]="uploadKeyControl"
                />
              </mat-form-field>             
            </div>

            <div class="spacer2"></div>


            <div class="form-field" style="width: 100%">
            <div class="wid-80px" style="float: left; width: 180px;"></div>
            <div style="float: left; width: calc(100% - 180px);">
<div
                style="
                  color: #131212;
    font-size: 12px;
    font-style: italic;
    font-weight: 300;
    text-align: left;
    width: 99%;
                "
              >
                <i
                  class="fa-solid fa-quote-left"
                  style="font-size: 14px; color: #1b8a9e"
                ></i>
                For AI analysis, please provide your own OpenAI API key. Your
                interactions will be processed exclusively using your key. You
                can create one by signing in at
                <a
                  href="https://platform.openai.com/account/api-keys"
                  target="_blank"
                  rel="noopener noreferrer"
                  >OpenAI</a
                >.
              </div>
            </div>
            </div>
             
          </div>
          <div class="button-container" style="text-align: right">
            <!-- <button mat-raised-button color="accent"  (click)="cancel()" class="ml5">{{ "Cancel" }}</button> -->
            <button
              mat-raised-button
              color="primary" [disabled]="uploadKeyControl.invalid"
              class="clr-white"
              (click)="submitLLMKey()"
            >
              {{ "Submit" }}
            </button>
          </div>
        </div>

      </div>
    <!-- CONFIG WORKSPACE -->



    <!-- SELECT PLAN -->
      <div class="step-nav" *ngIf="planNav">
        <div class="step-nav">

          <div [formGroup]="selectPlanForm" class="form-fields">
            <input type="hidden" [value]="currentApiKey" #hiddenApiKey />
            <input
              type="hidden"
              [value]="currentWorkspaceName"
              #hiddenWorkspaceName
            />

            <div class="step-container">
              <div
                style="margin: auto; width: max-content; box-sizing: border-box"
              >
                <div
                  style="
                    margin: 20px 0 40px 0;
                    text-align: center;
                    font-size: 25px;
                  "
                >
                  Select your plan
                </div>

                <div style="padding-bottom: 30px; width: 100%; float: left">
                  <div class="sunblog bg-white-bdr" style="margin-right: 20px">
                    <div class="mtb5"><b>Free</b></div>
                    <div class="mtb5">
                      <span style="vertical-align: super">$</span
                      ><span style="font-size: 25px">0</span
                      ><span style="color: #999; font-size: 13px">/Month</span>
                    </div>
                    <div class="mtb5">
                      For developers to get started with XDB
                    </div>
                    <!-- <div class="mtb5" style="margin:10px 0 0 0;">
            <button mat-raised-button color="primary" (click)="selectPlan('free')" class="btn-send clr-white w100p">Select</button></div> -->
                    <div class="subclist">
                      <ul>
                        <li>1K memories</li>
                        <li>Unlimited end users</li>
                        <li>1,000 retrieval API calls/month</li>
                      </ul>
                    </div>

                    <div
                      class="mtb5"
                      style="
                        margin: 10px 0 0 0;
                        position: absolute;
                        bottom: 20px;
                        width: calc(100% - 40px);
                      "
                    >
                      <button
                        mat-raised-button
                        color="primary"
                        (click)="selectPlan('free')"
                        class="btn-free clr-white w100p"
                      >
                        Select
                      </button>
                    </div>
                  </div>

                  <div class="sunblog bg-white-bdr">
                    <div class="mtb5"><b>Starter</b></div>
                    <div class="mtb5">
                      <span style="vertical-align: super">$</span
                      ><span style="font-size: 25px">18</span
                      ><span style="color: #999; font-size: 13px">/Month</span>
                    </div>
                    <div class="mtb5">
                      Ideal for users who need expanded memory storage and advanced inferencing capabilities.
                    </div>
                    <div class="subclist">
                      <ul>
                        <li>5K memories</li>
                        <li>Unlimited users</li>
                        <li>50K API calls/month</li>                                                
                        <li>Multiple workspaces support</li>
                      </ul>
                    </div>

                    <div
                      class="mtb5"
                      style="
                        margin: 10px 0 0 0;
                        position: absolute;
                        bottom: 20px;
                        width: calc(100% - 40px);
                      "
                    >
                      <button
                        mat-raised-button
                        color="primary"
                        (click)="selectPlan('starter')"
                        class="btn-pro clr-white w100p"
                      >
                        Select
                      </button>
                      <!-- <div class="btn-pro clr-white w100p">Comming Soon...</div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    <!-- SELECT PLAN -->

    </div>


    </div>
  </div>
</div>


